/** Whether a URL is likely a direct image resource (not an HTML page). */
export function looksLikeImageUrl(url) {
  if (!url || typeof url !== 'string') return false;
  return (
    /\.(jpe?g|png|gif|webp|bmp|svg|avif)(\?|#|$)/i.test(url) ||
    /googleusercontent\.com|gstatic\.com|ytimg\.com|fbcdn\.net|cloudfront\.net/i.test(url) ||
    /\/(thumb|thumbnail|image|img|media|photo)/i.test(url)
  );
}

export function getMatchPageUrl(info) {
  const backlink = info?.backlinks?.[0]?.backlink || info?.backlinks?.[0]?.url || '';
  if (backlink.startsWith('http')) return backlink;
  if (info?.domain) {
    const d = info.domain.startsWith('http') ? info.domain : `https://${info.domain}`;
    return d;
  }
  return backlink ? `https://${backlink}` : '';
}

/** Thumbnail for <img>; avoids using HTML page URLs as image src (CORS / broken icons). */
export function getMatchThumbnailUrl(info) {
  const imageUrl = info?.image_url || '';
  const legacyUrl = info?.backlinks?.[0]?.url || '';
  const pageUrl = info?.backlinks?.[0]?.backlink || '';

  if (looksLikeImageUrl(imageUrl)) return imageUrl;
  if (looksLikeImageUrl(legacyUrl) && legacyUrl !== pageUrl) return legacyUrl;
  if (looksLikeImageUrl(pageUrl)) return pageUrl;
  return '';
}

export function getMatchDomain(info) {
  if (info?.domain) return info.domain;
  try {
    const u = new URL(getMatchPageUrl(info));
    return u.hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
}
